import _ from 'lodash';

import { PatchValueType } from 'constants/patchValue';

// Request shape of the backend PatchValue<T> for the user's own edit; a null value clears the field.
export const toDirectPatchValue = value => ({ type: PatchValueType.DIRECT, value: value ?? null });

// A value the form derived from the user's other edits; the backend applies it but does not credit it to the user.
export const toRecalculatedPatchValue = value => ({
  type: PatchValueType.RECALCULATED,
  value: value ?? null,
});

const isNumericLike = value =>
  (_.isNumber(value) || (_.isString(value) && value.trim() !== '')) &&
  Number.isFinite(Number(value));

// A field typed back to its loaded value can come out as '100000' where it loaded as 100000.
const toComparableValue = value => (isNumericLike(value) ? Number(value) : value);

const isSameRequestValue = (value, otherValue) =>
  _.isEqual(toComparableValue(value), toComparableValue(otherValue));

// Builds a field-level patch from two request bodies built the same way: one from the edited form and one from the
// form as it was opened. Only keys the edited request carries and whose value changed are sent.
export const getPatch = ({ current, baseline, keys, isRecalculatedKey = _.stubFalse }) =>
  keys.reduce((patch, key) => {
    if (!_.has(current, key) || isSameRequestValue(current[key], baseline?.[key])) {
      return patch;
    }

    const toPatchValue = isRecalculatedKey(key) ? toRecalculatedPatchValue : toDirectPatchValue;

    return { ...patch, [key]: toPatchValue(current[key]) };
  }, {});
